/**
 * Application root.
 *
 * Only three things live here: the query client provider, the router, and the
 * document language bridge. Everything else belongs to a page or a hook.
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { RouterProvider } from 'react-router'

import { queryClient } from './lib/query'
import { router } from './router'

/**
 * Mirrors the active language onto `<html lang>`, which assistive technology and
 * browser translation both rely on.
 */
function DocumentLanguage() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return null
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DocumentLanguage />
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
